import type { ParamsValidator } from 'src/components/RouteParamsValidator';
import { ProductTypes } from '../../constants';
import type { BroadcastRouteParams } from './types';
import { BroadcastUrlTypes } from './types';

export const validateBroadcastType: ParamsValidator<BroadcastRouteParams> = ({ broadcastType }) =>
  Object.values(BroadcastUrlTypes).includes(broadcastType);

export const getProductTypeByBroadcast = (broadcastType?: BroadcastUrlTypes) => {
  switch (broadcastType) {
    case BroadcastUrlTypes.TV:
      return ProductTypes.TV;
    case BroadcastUrlTypes.RADIO:
    default:
      return ProductTypes.RADIO;
  }
};
